import { FC } from "react";
import SRC_1 from "./images/1.jpg";
import SRC_2 from "./images/2.jpg";

export const LoveLineTemplate1: FC = () => {
  return (
    <div className="template-1">
      <div
        className="date"
        data-parallax="3"
        data-animation-direction="fade"
        data-animation-delay="350"
      >
        <span className="neela-style" style={{ fontWeight: 300 }}>
          <span className="h-lines"></span>
          <span className="v-lines"></span>04 January
        </span>
      </div>

      <div
        id="loveline-1"
        className="image-1"
        data-parallax="-4"
        data-animation-direction="from-left"
        data-animation-delay="250"
      >
        <img alt="" src={SRC_1} />
      </div>

      <div
        id="loveline-2"
        className="image-2"
        data-parallax="6"
        data-animation-direction="from-right"
        data-animation-delay="250"
      >
        <div style={{ backgroundImage: "url(images/loveline/3.jpg)" }}></div>
        <img alt="" src={SRC_2} />
      </div>

      <div
        className="description-wrapper"
        data-parallax="-6"
        data-animation-direction="from-bottom"
        data-animation-delay="250"
      >
        <div
          className="description"
          data-parallax="-6"
          data-animation-direction="from-bottom"
          data-animation-delay="250"
        >
          <div className="neela-style">
            <span className="h-lines"></span>
            <span className="v-lines"></span>
            <h4 style={{ fontWeight: 300 }}>Our first date</h4>
            <p>
              Our first date was unexpected. Andrey's taste in music won me
              over, so I showed up in a tracksuit, relaxed. We laughed until
              tears. When we said goodbye, we knew this was just the start of
              something special - many more nights of laughter and music to come.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
